import { render, staticRenderFns } from "./page-dynamic-grid.vue?vue&type=template&id=134df8d0&"
import script from "../../../js/views/dynamic-grid/page-dynamic-grid.js?vue&type=script&lang=js&"
export * from "../../../js/views/dynamic-grid/page-dynamic-grid.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports